import { CrownIcon } from '../../assets/icons';
import { formatPercentages, formatUSD } from '../../helpers';
import ShareModal, { ShareModalType } from './ShareModal';
import useModalState from '../../context/modal/useModalState';
import { LeaderboardDto } from '../../context/leaderboard/leaderboardTypes';

const SharePnlRanking = () => {
    const { modalData } = useModalState();

    const userData: (LeaderboardDto & { rank: number }) | undefined =
        modalData.data?.position;

    if (!userData || modalData.data?.type !== ShareModalType.PnL) return null;

    return (
        <ShareModal
            modalName='sharePnlRankingModal'
            type={ShareModalType.PnL}
            cardClass='user-pnl-ranking'
        >
            <span className={`rank rank-${userData?.rank + 1}`}>
                Rank: {userData?.rank + 1}{' '}
                {userData && userData?.rank < 3 ? <CrownIcon /> : null}
            </span>
            <span>PnL</span>
            <div
                className={`trading-score ${
                    +userData.realizedPnL >= 0 ? 'increased' : 'decreased'
                }`}
            >
                <span className='pnl-value'>{formatUSD(userData?.realizedPnL || 0)}</span>
                <span className='pnl-percentage'>
                    ({userData && +userData.realizedPnL > 0 && '+'}
                    {formatPercentages(userData?.realizedPnLPercentage.toString() || 0)}
                    %)
                </span>
            </div>
            <div className='win-lose'>
                <span>Win: {userData?.wins || 0}</span>
                <span>Loss: {userData?.losses || 0}</span>
            </div>
        </ShareModal>
    );
};

export default SharePnlRanking;
